// extracted by mini-css-extract-plugin
module.exports = {"icon":"_7a3fb80146--icon--xr0wo","icon--opened":"_7a3fb80146--icon--opened--SaQoY","button":"_7a3fb80146--button--P2iHs"};